module.exports = __webpack_public_path__ + "assets/img/Pioneer_MartinRoland_cover.902ceb42-ps.jpg";